var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 28,
    height: 36,
    rx: 5,
    fill: "#DDF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.09375H18V42.0938H27C29.7614 42.0938 32 39.8552 32 37.0938V14H27C25.3431 14 24 12.6569 24 11V6.09375Z",
    fill: "#C2E0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 17.4477 8.44772 17 9 17H18V19H9C8.44772 19 8 18.5523 8 18Z",
    fill: "#56AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H27C27.5523 17 28 17.4477 28 18C28 18.5523 27.5523 19 27 19H18V17Z",
    fill: "#3689DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 23.4477 8.44772 23 9 23H18V25H9C8.44772 25 8 24.5523 8 24Z",
    fill: "#56AEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H24C24.5523 23 25 23.4477 25 24C25 24.5523 24.5523 25 24 25H18V23Z",
    fill: "#3689DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29H24C24.5523 29 25 29.4477 25 30C25 30.5523 24.5523 31 24 31H18V29Z",
    fill: "#3689DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30C8 29.4477 8.44772 29 9 29H18V31H9C8.44772 31 8 30.5523 8 30Z",
    fill: "#56AEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36.9844,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#3689DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1214 34.9202L23.5356 29.2633L27.7782 33.506L22.1214 34.9202Z",
    fill: "#FEEBCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3841 34.3546L22.1215 34.9202H22.1213L22.687 32.6575L24.3841 34.3546Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6777 15.1213L40.5062 17.9498L26.364 32.0919L23.5356 29.2635L37.6777 15.1213Z",
    fill: "#FF5757"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5061 17.9497L41.9203 19.3639L27.7782 33.5061L26.364 32.0918L40.5061 17.9497Z",
    fill: "#CF1414"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6777 15.1213L41.9204 19.364L42.5741 18.7102C43.7457 17.5387 43.7457 15.6392 42.5741 14.4676C41.4025 13.296 39.503 13.296 38.3315 14.4676L37.6777 15.1213Z",
    fill: "#4D94FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6777 15.1213L41.9203 19.364L42.6274 18.6569L38.3848 14.4142L37.6777 15.1213Z",
    fill: "#A0C6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocForm);
export default __webpack_public_path__ + "static/media/DocForm.ca220db14a565a2eb821aa1926159db5.svg";
export { ForwardRef as ReactComponent };